import { Trans } from '@lingui/react'

import withShopAndRuntimeConfig from 'views/enhancers/withShopAndRuntimeConfig'

type IdSwitcherProps = {
  ean?: string
  isbn?: string
  pzn?: string
  uid: string
  upid?: string
  displayCode?: string
}

type LabelAndIdPair = {
  label: string
  id: string
}

/**
 * Label and Id pairing logic
 */
export const genLabelAndIdPair = ({
  pzn,
  ean,
  upid,
  isbn,
  uid,
  displayCode,
}: IdSwitcherProps): LabelAndIdPair => {
  const labels = {
    pznIsbn: /*i18n*/ 'general.label.pznIsbn',
    pznEan: /*i18n*/ 'general.label.pznEan',
    pzn: /*i18n*/ 'general.label.pzn',
    isbn: /*i18n*/ 'general.label.isbn',
    ean: /*i18n*/ 'general.label.ean',
    upid: /*i18n*/ 'general.label.upid',
  }
  const code = displayCode || pzn

  if (code && isbn) {
    return { label: labels.pznIsbn, id: `${code}/${isbn}` }
  }
  if (code && isbn && ean) {
    return { label: labels.pznIsbn, id: `${code}/${isbn}` }
  }
  if (code && isbn && ean && upid) {
    return { label: labels.pznIsbn, id: `${code}/${isbn}` }
  }
  if (code && ean) {
    return { label: labels.pznEan, id: `${code}/${ean}` }
  }
  if (code) {
    return { label: labels.pzn, id: code }
  }
  if (isbn) {
    return { label: labels.isbn, id: isbn }
  }
  if (ean) {
    return { label: labels.ean, id: ean }
  }
  if (upid) {
    return { label: labels.upid, id: upid }
  }
  if (uid) {
    return { label: labels.upid, id: uid }
  }
  throw new Error('Neither PZN nor EAN nor UPID is available')
}

/**
 * Shows relevant ID based on logic
 * WSPMP-12
 */
const IdSwitcher = (params: IdSwitcherProps): JSX.Element => {
  const {
    pzn = '',
    ean = '',
    upid = '',
    isbn = '',
    uid = '',
    displayCode = '',
  } = params

  const { id, label } = genLabelAndIdPair({
    pzn,
    ean,
    upid,
    uid,
    isbn,
    displayCode,
  })
  return (
    <>
      <Trans id={label} />: {id}
    </>
  )
}

export default withShopAndRuntimeConfig(IdSwitcher)
